<template>
  <div>
    <b-button-group size="sm">
      <b-button variant="warning" :title="showToolTip ? 'Добавить файл' : ''" @click="addFile"><i class="fa fa-plus"></i></b-button>
      <b-button :variant="state ? '' : 'danger'" @click="addFile">{{text !== '' ? text + ': ' : ''}}{{files.length}}</b-button>
      <b-button v-if="files.length > 0" variant="danger" :title="showToolTip ? 'Очистить' : ''" @click="clearFiles"><i class="fa fa-remove"></i></b-button>
    </b-button-group>    
    <input ref="uploader" class="d-none" type="file" accept="image/*;capture=camera" @change="onFileChanged"/>
  </div>
</template>

<script>

export default ({
  name: "button-add-files",

  props: {    
    text: {
      type: String,
      default: ''
    },

    state: {
      type: Boolean,
      default: true
    },
  },

  data: function() {
    return {
      isSelecting: false,
      files: []
    }
  },

  computed: {
    showToolTip() {
      return this.$store.state.userSettings.showTooltips;
    }
  },
  
  methods: {
    addFile() {
      this.isSelecting = true;

      // After obtaining the focus when closing the FilePicker, return the button state to normal
      window.addEventListener('focus', () => {
          this.isSelecting = false
      }, { once: true });
      
      // Trigger click on the FileInput
      this.$refs.uploader.click();
    },

    clearFiles() {
      this.files = []
      this.$emit('clearFiles')
    },

    onFileChanged(e) {
      this.files.push(e.target.files[0])
      this.$emit('onAddFile', this.files)
    }
  }
})
</script>
